require('slick-carousel');

//todo data attribute behaviour
$(document).ready(function(){
    $('input[type="email"]').bind("cut copy paste",function(e) {
        e.preventDefault();
    });
});

$(function(){
    /**
     * Show target element on click
     *
     * Usage example:
     *
     *
     * <a data-show="#hidden-box" data-show-alt-html="Hide visible box" href="#">Show hidden box</a>
     *
     * <div id="hidden-box" class="hide">
     *     I am hidden
     * </div>
     *
     */
    $(document).on('click', '[data-show]', function(e){
        e.preventDefault();
        var link = $(this);
        var scrollTo = link.is('[data-show-scroll-to]');
        var hideLink = link.is('[data-show-hide-link]');
        var style = 'hide';
        if(link.data('show-style')){
            style = link.data('show-style');
        }
        var defaultHtml = link.data('show-default-html');
        if(!defaultHtml){
            defaultHtml = link.html();
            link.data('show-default-html', defaultHtml);
        }
        var altHtml = link.data('show-alt-html');
        if(!altHtml){
            altHtml = defaultHtml;
            link.data('show-alt-html', altHtml);
        }
        var selector = link.data('show');
        var target = $(selector);
        //hide
        if(target.is(':visible')){
            link.removeClass('active');
            if(style == 'hide'){
                target.addClass('hide');
            }
            else if(style == 'slide'){
                target.slideUp();
            }
            link.html(defaultHtml);
            //app.reflow();
        }
        //show
        else{
            link.addClass('active');
            target.removeClass('hide hide-for-small hide-for-medium-down');
            if(style == 'slide'){
                target.slideDown();
            }
            link.html(altHtml);
            if(hideLink){
                link.css('display', 'none');
            }
            if(scrollTo){
                setTimeout(function(){
                    $.scrollTo(target, {
                        'duration': 250,
                        'offset': -50
                    });
                }, 250);
            }
            //app.reflow();
        }
    });
});

$(function(){
    $('.testimonials-big').slick({
        dots: false,
        infinite: true,
        fade: false,
        arrows: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
$(function(){
    $('.location-slider').slick({
        dots: false,
        infinite: true,
        fade: true,
        arrows: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
$(function(){
    $('.cruise-driver--carousel:not(.cruise-checkbox--carousel)').slick({
        dots: true,
        infinite: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 730,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });

    $('.cruise-driver--carousel').on('afterChange', function(event, slick, direction){
        window.lazy.update();
    });
});
$(function(){
    $('.cruise-checkbox--carousel').slick({
        dots: true,
        infinite: false,
        autoplay: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 730,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });
});

$(function(){
    $(document).on('click', '[data-show-fewer]', function(e){
        e.preventDefault();
        $('#advanced-search').hide();
        $(this).addClass('hide');
        $('[data-show-more]').removeClass('hide');
        window.scrollToHash('#cruise_search_form_show_more');
    });

    $(document).on('click', '[data-show-more]', function(e){
        e.preventDefault();
        $('#advanced-search').show();
        $(this).addClass('hide');
        $('[data-show-fewer]').removeClass('hide');
    });
});

// Details Sticky Header & Move to section Start
$(function(){
    if($('[data-cruise-details-tab-trigger]').length > 0) {
        // Creates Sticky Header when top of screen passes $('[data-cruise-details-tab-trigger]')
        var element_position = $('[data-cruise-details-tab-trigger]').offset().top;

        $(window).on('scroll', function () {
            var y_scroll_pos = window.pageYOffset;
            var currentPageText = $('[data-current-page]');

            if (y_scroll_pos > element_position) {
                $('[data-cruise-details-tab-container]').addClass('stick-to-top');
                $('[data-fixed-menu-buffer]').addClass('active');
                $('[data-mobile-navigation-list]').addClass('active');

                $('[data-section-trigger]').each(function () {

                    var sectionValue = ($(this).data('section-trigger'));
                    var sectionContainer = $('[data-section~="' + sectionValue + '"]');
                    var sectionPositionTop = sectionContainer.offset().top;
                    var sectionPositionBottom = sectionContainer.outerHeight(true) + sectionPositionTop;
                    var lastSectionUpdate = null;

                    // prefer next section when scroll is close to the bottom of one and top of the next section
                    var preferBottomByPx = 5;


                    if($('[data-tab-click]').length > 0){
                        if((y_scroll_pos + 200) > sectionPositionTop && (y_scroll_pos - 200) < sectionPositionBottom){
                            $('[data-mobile-navigation-list-item]').each(function() {
                                var $this = $(this);
                                var tab = $(this).find('[data-tab-click]').attr('data-tab-click');
                                if($(tab).parent().hasClass('is-active')){
                                    $this.addClass('active');
                                } else {
                                    $this.removeClass('active');
                                }
                            });
                        } else {
                            $('[data-mobile-navigation-list-item]').removeClass('active');
                        }


                    } else if (y_scroll_pos > sectionPositionTop - preferBottomByPx && y_scroll_pos < sectionPositionBottom - preferBottomByPx) {
                        if (lastSectionUpdate !== sectionValue) {
                            currentPageText.text($('[data-tab-button="' + sectionValue + '"]').text());
                            $('[data-tab-button]').removeClass('active');
                            $('[data-tab-button="' + sectionValue + '"]').addClass('active');
                        }
                        lastSectionUpdate = sectionValue;
                    }


                });



            } else {
                $('[data-cruise-details-tab-container]').removeClass('stick-to-top');
                $('[data-fixed-menu-buffer]').removeClass('active');
                $('[data-mobile-navigation-list]').removeClass('active');
                $('[data-tab-button]').removeClass('active');
                currentPageText.text('On this Page..');
            }
        });

        // Toggles Sticky Header Menu list
        $('[data-mobile-navigation-toggle]').click(function (e) {
            e.preventDefault();
            $('[data-current-page-arrow]').toggleClass('fa-rotate-180');
            $('[data-mobile-navigation-list]').toggleClass('open');
        });

        // When Menu Item is selected this replaces the text at the top of the sticky relevant to selected section
        $('[data-mobile-navigation-list-item]').each(function () {
            var $this = $(this);

            //Remove link if refrenced section is empty
            var name = $this.attr('data-tab-button');
            var sectionSelector = '[data-section~="' + name + '"]';
            var section = $(sectionSelector);

            if(section.length == 0){
                //$this.remove();
                return;
            }

            $($this.find('[data-tab-click]').attr('data-tab-click')).click(function(){
                $('[data-mobile-navigation-list]').removeClass('open');
                $this.addClass('active');
            })
        });

        $('[data-tab-click]').click(function (e){
            e.preventDefault();
            $('[data-mobile-navigation-list]').removeClass('open');
            let target = $('a[href="' + $(this).attr('data-tab-click') + '"]');
            target.parent('.tabs-title').click();
        });
    }
});

// flashmsg callout js
$(function(){
    if($('.callout').length > 0){
        $('.callout').each(function(){
            var $callout = $(this);
            $callout.find('.close-button').click(function(e){
                e.preventDefault();
                $callout.slideUp();
            });
        });
    }
});

$(document).ready(function(){
    let hash = window.location.hash;
    if(hash === '#first-promo') {
        $('[data-promo-item]').show();
        $('html, body').animate({
            scrollTop: $("#first-promo").offset().top
        }, 0);

        $('[data-toggle-promos-more]').hide();
        $('[data-toggle-promos-less]').show();
    }

    $('[data-toggle-promos-more]').click(function(e) {
        let clickedURL = $(this).attr("href");
        history.replaceState(null, null, clickedURL);

        e.preventDefault();
        $('[data-promo-item]').show();
        $('html, body').animate({
            scrollTop: $("#first-promo").offset().top
        }, 1000);
        $('[data-toggle-promos-more]').hide();
        $('[data-toggle-promos-less]').show();
    });

    $('[data-toggle-promos-less]').click(function(e) {
        history.replaceState(null, null, '/cruise-deals');


        e.preventDefault();
        $('[data-promo-item]').hide();
        $('html, body').animate({
            scrollTop: $("#last-promo").offset().top
        }, 300);
        $('[data-toggle-promos-more]').show();
        $('[data-toggle-promos-less]').hide();
    });
});

// Stuff to handle payment buttons
$(function(){
    $('.index_payment_link').click(function(){
        //get balance and booking ID
        var index_booking_id = $(this).attr("data-indexbookingid");
        var index_balance = $(this).attr("data-indexbalance");
        $('.pay_amount_hide').val('');

        // update form
        $('#paymentSelectModal').attr('data-booking-id', index_booking_id);
        $('#paymentSelectModal').attr('data-balance', index_balance);

        // Update text area
        $('.balance_area').html(index_balance);

        // Check if "other amount" is selected and open text area
        if( $('input[name=payment_option]:checked').val() == 'part'){
            $('.pay_amount_hide').show();
        }

    });

    $('input[name=payment_option]').click(function() {
        if($(this).val() == 'part') {
            $('.pay_amount_hide').show();
        } else if($(this).val() == 'full'){
            $('.pay_amount_hide').hide();
        }
    });

    $('.make_payment_button').click(function(e){
        e.preventDefault();
        var payment_amount = $('input[name=payment_amount]').val();

        if( $('input[name=payment_option]:checked').val() != 'full' ) {
            if(isNaN(payment_amount) || payment_amount.length == 0) {
                $('.error_area').html('Please enter a number');
            }else{
                redirect_to_payment(payment_amount);
            }
        }else {
            redirect_to_payment(payment_amount);
        }
    });

    function redirect_to_payment(payment_amount){
        var bookingId = $('#paymentSelectModal').data('booking-id');
        if (bookingId == '') {
            bookingId = $('#paymentSelectModal').attr('data-booking-id');
        }
        var balance = $('#paymentSelectModal').data('balance');
        var full_payment_address = '/my-rol/bookings/pay-balance/' + bookingId;
        var payment_option = $('input[name=payment_option]:checked').val();
        if (balance == '') {
            balance = parseInt($('#paymentSelectModal').attr('data-balance'));
        }

        if (payment_amount > balance) {
            $('.error_area').html('Balance payment is too large');
        } else {
            if (payment_option == 'full') {
                window.location = full_payment_address;
            } else {
                if(payment_amount < 1) {
                    $('.error_area').html('Please enter a positive value');
                } else {
                    window.location = full_payment_address + '/' + payment_amount;
                }
            }
        }
    }
});